module.exports = __webpack_public_path__ + "static/media/periodicon.bd88d22c.png";